import React from 'react';
import _ from 'lodash';
import Tooltip from '@material-ui/core/Tooltip';
import { LINE_HEIGHT } from 'common/constants/sizes';
import { multipleTeamsTooltip } from 'components/Tooltips/helpers';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import TeamAvatar from 'components/base/TeamAvatar';
import Icon from 'components/base/Icon';
import { sizes } from 'styles/dropdown.style';
import styled from 'styled-components';
import { boolPropsToClassNames } from 'common/utils/style.utils';

const StyledTeamAvatar = styled(Flex)`
  &.disabled {
    filter: grayscale(1);
  }
`;

const TreeTeamsSelectedTooltip = ({ teams }) => {
  const teamsNames =
    teams.map(({ origin: { name = '', isNotFound = false } }) =>
      isNotFound ? `${name} (not under root)` : name
    ) || [];
  teamsNames.join(', ');

  return (
    <Flex padding='x-small' direction='column' maxWidth='20rem'>
      <Text size='medium' weight='500'>
        {teams.length} teams selected
      </Text>
      <Text
        size='medium'
        lineHeight={LINE_HEIGHT.medium}
        color='shuttleGray'
        pt='0.5rem'
      >
        {teamsNames.join(', ')}
      </Text>
    </Flex>
  );
};

const TreeTeamsSelected = ({
  teams,
  size = 'medium',
  teamsNotFound = false,
  disabled = false,
  customPlaceholder = null
}) => {
  const { height, textSize, selectedAvatarSize } = _.get(sizes, [size], {});

  if (typeof customPlaceholder === 'function') {
    return customPlaceholder(teams);
  }

  if (!teams.length) {
    return null;
  }

  if (teams.length > 1) {
    return (
      <Tooltip
        title={<TreeTeamsSelectedTooltip teams={teams} />}
        placement='bottom-start'
        classes={multipleTeamsTooltip()}
      >
        <Flex items='center' width='100%' height={height}>
          Multiple teams ({teams.length})
        </Flex>
      </Tooltip>
    );
  }

  const { origin = {} } = teams[0];
  const { name } = origin;
  return (
    <>
      <Flex items='center' width='100%' height={height} grow='1'>
        <StyledTeamAvatar className={boolPropsToClassNames({ disabled })}>
          {teamsNotFound ? (
            <Icon name='warning' color='orangePeel' size='medium' />
          ) : (
            <TeamAvatar team={origin} size={selectedAvatarSize} />
          )}
        </StyledTeamAvatar>
        <Tooltip
          title={`${name}`}
          placement='bottom-start'
          disableHoverListener={disabled}
        >
          <Text
            pl='1rem'
            pr='1rem'
            color='shark'
            size={textSize}
            ellipsisAfter='100%'
          >
            {teamsNotFound ? (
              <>
                <b>{name}</b> (not under root)
              </>
            ) : (
              name
            )}
          </Text>
        </Tooltip>
      </Flex>
    </>
  );
};

export default TreeTeamsSelected;
